import { useEffect } from "react";

import { useVectorPreview } from "@/hooks/use-vector-preview";
import { useFileQuery } from "@/queries/query-file";
import { getNameFromFileId } from "@/utils/get-name-from-file-id";

export function useSelectedFileOwn(id: string) {
  const { data: file, isLoading: isLoadingFile } = useFileQuery(id);
  const { isLoading, layers, bounds, visibleLayers, setVisibleLayers } = useVectorPreview({
    descriptorId: file?.descriptorId,
  });

  const descriptorId = file?.descriptorId ?? "none";

  useEffect(() => {
    setVisibleLayers(layers);
  }, [descriptorId, layers, setVisibleLayers]);

  const fileTitle = getNameFromFileId(file?.id ?? "");
  const layerNames = layers.map(({ layer }) => layer);

  return {
    descriptorId,
    layers,
    layerNames,
    isLoading: isLoadingFile || isLoading,
    bounds,
    fileTitle,
    visibleLayers,
    setVisibleLayers,
  } as const;
}
